import React from 'react';

const devpage = () => {
  return (
    <section className="hero is-success is-medium">
      <div className="hero-body">
        <div className="container">
        <h1 className="title">
          <i className='fas fa-grin-squint-tears'></i> Aaaaah!
        </h1>
        <h2 className="subtitle">
          This page is still in development. Not for long!
        </h2>
        </div>
      </div>
    </section>
  );
}

export default devpage;
